import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "twitter-solid",
  "use": "twitter-solid-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\" aria-label=\"Twitter\" role=\"img\" id=\"twitter-solid\"><rect fill=\"#1da1f3\" height=\"512\" rx=\"15%\" width=\"512\" /><path fill=\"#fff\" d=\"M465 135a150 150 0 0 1-47 13 83 83 0 0 0 37-46 150 150 0 0 1-52 20 83 83 0 0 0-141 75 230 230 0 0 1-169-85 80 80 0 0 0 26 109 83 83 0 0 1-37-9 83 83 0 0 0 65 80 83 83 0 0 1-37 2 83 83 0 0 0 77 57 150 150 0 0 1-122 34 230 230 0 0 0 359-208 150 150 0 0 0 41-42\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol